import React from 'react'
import { FileCode, FileImage, FileSpreadsheet, FileText } from 'lucide-react'

import { DateFormat } from '@/components/date-format.tsx'
import { Attachment } from '@/features/attachments/types.ts'
import { openAttachments } from '@/features/attachments/view-attachment.tsx'

const fileIcons: Record<string, typeof FileText> = {
  txt: FileText,
  js: FileCode,
  jsx: FileCode,
  ts: FileCode,
  tsx: FileCode,
  css: FileCode,
  html: FileCode,
  json: FileCode,
  xlsx: FileSpreadsheet,
  xls: FileSpreadsheet,
  csv: FileSpreadsheet,
  png: FileImage,
  jpg: FileImage,
  jpeg: FileImage,
  gif: FileImage,
  svg: FileImage,
  pdf: FileText,
  default: FileText,
}

export const AttachmentList: React.FC<{
  attachments?: Array<Attachment>
  actions?: (attachment: Attachment) => React.ReactNode
}> = ({ attachments, actions }) => (
  <ul className="divide-y divide-gray-100">
    {attachments?.map((attachment, index) => {
      const FileIcon =
        fileIcons[attachment.file.mime_type ?? ''] ?? fileIcons['default']

      return (
        <li
          key={attachment.id}
          className="flex items-center justify-between gap-x-6 px-4 py-5"
        >
          <div className="flex min-w-0 items-center gap-x-4">
            <FileIcon
              className="size-8 cursor-pointer text-gray-500"
              onClick={() =>
                openAttachments({
                  attachmentIds: attachments.map((a) => a.id),
                  currentIndex: index,
                })
              }
            />
            <div className="min-w-0 flex-auto">
              <p
                className="cursor-pointer text-sm font-semibold text-gray-900"
                onClick={() =>
                  openAttachments({
                    attachmentIds: attachments.map((a) => a.id),
                    currentIndex: index,
                  })
                }
              >
                {attachment.name}
              </p>
              <div className="mt-1 flex items-center gap-x-2 text-xs text-gray-500">
                <p className="whitespace-nowrap">
                  <DateFormat date={attachment.created_at} />
                </p>
                {/*<svg viewBox="0 0 2 2" className="size-0.5 fill-current">
                  <circle r={1} cx={1} cy={1} />
                </svg>
                <p className="truncate">By someone</p>*/}
              </div>
            </div>
          </div>
          {actions && (
            <div className="flex flex-none items-center gap-x-4">
              {/*<Button variant="outline" className="hidden sm:block">*/}
              {/*  View file<span className="sr-only">, {file.name}</span>*/}
              {/*</Button>*/}
              {actions(attachment)}
            </div>
          )}
        </li>
      )
    })}
  </ul>
)
